import type { BobState } from "../types";
import { computeDeckMetrics, STAGE_LABELS } from "../lib/engine/pipeline";

interface Props {
  state: BobState;
  onNavigate: (surface: BobState["activeSurface"]) => void;
}

export function CommandDeckPanel({ state, onNavigate }: Props) {
  const metrics = computeDeckMetrics(state);
  const compact = state.presentationMode;

  const cards = [
    { label: compact ? "Active" : "Active builds", value: metrics.activeBuilds, chip: "ok" as const },
    { label: compact ? "Queued" : "Queued / paused", value: metrics.queued, chip: "locked" as const },
    { label: compact ? "Agents" : "Agents engaged", value: metrics.agentsEngaged, chip: "ok" as const },
    { label: compact ? "Failures" : "Open failures", value: metrics.openFailures, chip: metrics.openFailures ? undefined : "ok" as const },
    { label: compact ? "Done" : "Completed handoffs", value: metrics.completed, chip: "ok" as const },
    { label: compact ? "Avg %" : "Average progress", value: `${metrics.avgProgress}%`, chip: undefined },
  ];

  return (
    <section className="surface glass-panel">
      <h2>{compact ? "Command Deck" : "Command Deck — Live Ops"}</h2>
      <p className="lead">
        {compact
          ? "Real-time build ops metrics."
          : "Live metrics from pipeline directives, agent board, and failure recovery state."}
      </p>

      <div className="deck-metrics">
        {cards.map((c) => (
          <div key={c.label} className="deck-metric">
            <div className="deck-metric-value">{c.value}</div>
            <div className="deck-metric-label">{c.label}</div>
            {c.chip && <span className={`chip ${c.chip}`}>{c.chip === "ok" ? "live" : "hold"}</span>}
          </div>
        ))}
      </div>

      <div className="btn-row">
        <button type="button" className="btn" onClick={() => onNavigate("pipeline")}>
          {compact ? "Pipeline" : "Open pipeline board"}
        </button>
        <button type="button" className="btn secondary" onClick={() => onNavigate("agents")}>
          {compact ? "Agents" : "View agent board"}
        </button>
        <button type="button" className="btn secondary" onClick={() => onNavigate("recovery")}>
          {compact ? "Recovery" : "Failure recovery"}
        </button>
      </div>

      {state.directives.length > 0 && (
        <div className="output-box" style={{ marginTop: "1rem" }}>
          {compact ? "Recent:\n" : "Recent directive activity:\n"}
          {state.directives
            .slice(-5)
            .reverse()
            .map(
              (d) =>
                `${d.name} · ${STAGE_LABELS[d.stage]} · ${d.progress}%${d.paused ? " [PAUSED]" : ""}`,
            )
            .join("\n")}
        </div>
      )}
    </section>
  );
}
